import * as types from './action-types';

export const setLang = lang => ({type: types.SET_LANG, lang});

export const mergeLang = lang => ({type: types.MERGE_LANG, lang});
